var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.501 18.1881C106.077 7.66962 118.255 0.724982 131.971 0.154847C200.478 -2.72643 225.577 35.3044 225.577 35.3044L178.484 89.5152L98.501 18.1881Z",
    fill: "url(#paint0_linear_237_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.483 89.5151L125.443 150.558C89.8968 117.252 87.2603 70.3324 90.6301 38.7771C91.4117 31.3447 94.1252 24.2464 98.5009 18.188C138.405 21.4364 170.867 51.006 178.483 89.5151Z",
    fill: "url(#paint1_linear_237_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.566 18.1881C451.99 7.66962 439.812 0.724982 426.096 0.154847C357.59 -2.72643 332.49 35.3044 332.49 35.3044L379.583 89.5152L459.566 18.1881Z",
    fill: "url(#paint2_linear_237_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.584 89.5151L432.624 150.558C468.17 117.252 470.808 70.3324 467.437 38.7771C466.655 31.3447 463.942 24.2464 459.566 18.188C419.662 21.4364 387.201 51.006 379.584 89.5151Z",
    fill: "url(#paint3_linear_237_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.608 97.2562C153.472 92.2852 151.437 87.5552 147.92 84.0391C138.953 75.0719 123.904 76.9282 117.451 87.8444C111.488 97.9275 106.489 108.55 102.521 119.572C107.922 130.556 115.354 141.106 125.443 150.558L154.563 132.152L153.608 97.2562Z",
    fill: "#FF75C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.961 182.894C435.961 269.563 365.702 299.092 279.033 299.092C192.364 299.092 122.105 269.563 122.105 182.894C122.105 96.2251 192.365 25.9658 279.034 25.9658C365.703 25.9658 435.961 96.2251 435.961 182.894Z",
    fill: "url(#paint4_linear_237_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.77 100.219C363.29 100.222 360.894 99.317 359.034 97.6757C354.402 93.5888 349.413 89.9255 344.127 86.7299C339.302 83.8231 337.748 77.5557 340.654 72.7305C343.561 67.9052 349.829 66.3498 354.654 69.2576C360.987 73.0848 366.964 77.4717 372.514 82.3656C376.741 86.0873 377.151 92.5322 373.429 96.7608C372.473 97.8494 371.294 98.7211 369.973 99.3175C368.652 99.914 367.219 100.221 365.77 100.219ZM318.559 73.0966C317.471 73.0963 316.391 72.9217 315.358 72.5795C305.794 69.4295 295.859 67.5406 285.806 66.9608C280.183 66.6324 275.89 61.8071 276.219 56.1843C276.547 50.5615 281.371 46.2707 286.995 46.597C298.821 47.2801 310.506 49.5033 321.756 53.2102C327.105 54.9767 330.008 60.7454 328.241 66.0938C326.825 70.3795 322.838 73.0966 318.559 73.0966Z",
    fill: "#938EA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.863 438.616H142.535C102.041 438.616 65.2505 414.706 48.8042 377.704C40.3165 358.606 42.0483 336.744 53.4357 319.22C64.8231 301.698 84.0986 291.236 104.997 291.236H136.511V331.965H104.997C97.8349 331.965 91.4889 335.41 87.5867 341.415C83.6845 347.42 83.1144 354.618 86.0232 361.162C95.9388 383.472 118.12 397.888 142.535 397.888H191.863V438.616Z",
    fill: "url(#paint5_linear_237_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.036 478.302C386.674 460.044 377.229 449.781 377.229 449.781L279.033 425.38L180.837 449.781C180.837 449.781 171.391 460.045 165.029 478.302C159.289 494.775 171.509 512 188.954 512H369.11C386.557 512 398.777 494.776 393.036 478.302Z",
    fill: "url(#paint6_linear_237_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.602 388.366C117.93 404.305 128.859 421.217 143.162 438.617H191.863V397.888H142.535C130.879 397.884 119.461 394.583 109.602 388.366ZM85.6794 316.78C86.7591 324.016 88.2262 331.189 90.0743 338.268C93.9398 334.223 99.2005 331.964 104.999 331.964H136.513V291.235H104.999C98.7548 291.235 92.6577 292.175 86.8707 293.953C84.9612 301.407 84.5562 309.167 85.6794 316.78Z",
    fill: "#FF75C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.232 270.835H142.835C119.965 270.835 102.51 291.17 105.858 313.793C110.825 347.358 128.09 397.033 180.838 449.782H377.229C429.977 397.033 447.242 347.358 452.209 313.793C455.557 291.171 438.103 270.835 415.232 270.835Z",
    fill: "url(#paint7_linear_237_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.546 212.84C197.946 212.84 204.755 207.368 204.755 200.618C204.755 193.868 197.946 188.396 189.546 188.396C181.146 188.396 174.337 193.868 174.337 200.618C174.337 207.368 181.146 212.84 189.546 212.84Z",
    fill: "#FD9BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.522 212.84C376.921 212.84 383.731 207.368 383.731 200.618C383.731 193.868 376.921 188.396 368.522 188.396C360.122 188.396 353.312 193.868 353.312 200.618C353.312 207.368 360.122 212.84 368.522 212.84Z",
    fill: "#FD9BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.619 200.618C232.275 200.618 245.777 187.116 245.777 170.46C245.777 153.804 232.275 140.302 215.619 140.302C198.964 140.302 185.461 153.804 185.461 170.46C185.461 187.116 198.964 200.618 215.619 200.618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.448 200.618C359.103 200.618 372.606 187.116 372.606 170.46C372.606 153.804 359.103 140.302 342.448 140.302C325.792 140.302 312.29 153.804 312.29 170.46C312.29 187.116 325.792 200.618 342.448 200.618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.581 181.093C224.21 181.094 222.863 180.727 221.683 180.029C220.502 179.332 219.531 178.329 218.871 177.127C217.917 175.393 216.279 175.205 215.619 175.205C214.959 175.205 213.321 175.393 212.368 177.127C211.39 178.905 209.747 180.222 207.798 180.788C205.85 181.354 203.757 181.123 201.979 180.145C200.201 179.168 198.884 177.524 198.318 175.576C197.752 173.628 197.984 171.534 198.961 169.757C200.601 166.773 203.012 164.285 205.942 162.552C208.873 160.819 212.215 159.904 215.619 159.904C219.024 159.904 222.366 160.819 225.296 162.552C228.227 164.285 230.638 166.773 232.278 169.757C232.918 170.921 233.244 172.232 233.224 173.561C233.204 174.889 232.838 176.19 232.162 177.334C231.486 178.478 230.523 179.427 229.369 180.086C228.216 180.745 226.91 181.092 225.581 181.093ZM332.486 181.093C331.157 181.092 329.852 180.745 328.698 180.085C327.544 179.426 326.582 178.478 325.906 177.334C325.23 176.19 324.864 174.889 324.844 173.56C324.823 172.232 325.15 170.921 325.79 169.757C327.43 166.773 329.841 164.285 332.772 162.552C335.702 160.819 339.044 159.905 342.448 159.905C345.852 159.905 349.194 160.819 352.124 162.552C355.055 164.285 357.466 166.773 359.106 169.757C360.083 171.534 360.314 173.627 359.749 175.576C359.183 177.524 357.866 179.168 356.089 180.145C354.311 181.122 352.218 181.352 350.27 180.787C348.322 180.221 346.678 178.905 345.7 177.127C344.745 175.393 343.107 175.205 342.447 175.205C341.789 175.205 340.151 175.393 339.196 177.127C338.536 178.329 337.564 179.331 336.384 180.029C335.203 180.727 333.857 181.094 332.486 181.093ZM290.917 210.99H267.15C260.522 210.99 255.15 205.618 255.15 198.991C255.15 192.363 260.522 186.991 267.15 186.991H290.917C297.543 186.991 302.916 192.363 302.916 198.991C302.916 205.618 297.544 210.99 290.917 210.99Z",
    fill: "#383842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.646 206.554C136.51 207.069 120.328 211.098 108.394 229.446C106.267 232.717 106.704 237.159 109.723 239.631C110.543 240.308 111.498 240.804 112.524 241.085C113.549 241.366 114.623 241.427 115.674 241.263C116.725 241.099 117.729 240.714 118.62 240.133C119.511 239.552 120.269 238.789 120.843 237.894C129.314 224.696 140.674 221.92 147.425 221.56C149.088 221.476 150.677 220.841 151.941 219.756C153.205 218.67 154.073 217.196 154.408 215.564C155.393 210.741 151.561 206.304 146.646 206.554ZM154.373 180.346C153.526 179.456 133.258 158.703 102.028 171.739C100.2 172.516 98.7532 173.984 98.0039 175.824C97.2546 177.663 97.2634 179.725 98.0284 181.558C98.7934 183.391 100.253 184.847 102.087 185.608C103.922 186.369 105.983 186.373 107.821 185.62C129.224 176.687 142.866 190.098 143.518 190.758C144.797 192.086 146.521 192.896 148.36 193.033C149.876 193.147 151.39 192.8 152.705 192.036C154.019 191.272 155.071 190.128 155.722 188.754C156.373 187.381 156.593 185.842 156.352 184.341C156.111 182.84 155.421 181.447 154.373 180.346ZM411.421 206.554C421.557 207.069 437.739 211.098 449.673 229.446C451.8 232.717 451.363 237.159 448.344 239.631C447.524 240.308 446.569 240.804 445.544 241.085C444.518 241.366 443.444 241.427 442.393 241.263C441.342 241.099 440.338 240.714 439.447 240.133C438.556 239.552 437.798 238.789 437.224 237.894C428.753 224.696 417.393 221.92 410.643 221.56C408.979 221.476 407.39 220.841 406.126 219.756C404.862 218.67 403.994 217.196 403.659 215.564C402.674 210.741 406.506 206.304 411.421 206.554ZM403.694 180.346C404.541 179.456 424.809 158.703 456.039 171.739C457.867 172.516 459.314 173.984 460.063 175.824C460.812 177.663 460.804 179.725 460.039 181.558C459.274 183.391 457.815 184.847 455.98 185.608C454.145 186.369 452.084 186.373 450.246 185.62C428.843 176.687 415.202 190.098 414.549 190.758C413.27 192.086 411.546 192.896 409.707 193.033C408.191 193.147 406.677 192.8 405.362 192.036C404.048 191.272 402.996 190.128 402.345 188.754C401.694 187.381 401.474 185.842 401.715 184.341C401.956 182.84 402.646 181.447 403.694 180.346Z",
    fill: "#4F4C5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.18 245.632C166.802 245.632 149.473 262.962 149.473 284.339C149.473 296.875 159.635 307.038 172.171 307.038H204.187C216.723 307.038 226.886 296.875 226.886 284.339C226.887 262.962 209.556 245.632 188.18 245.632Z",
    fill: "url(#paint8_linear_237_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.888 245.632C391.265 245.632 408.595 262.962 408.595 284.339C408.595 296.875 398.432 307.038 385.896 307.038H353.88C341.344 307.038 331.182 296.875 331.182 284.339C331.182 262.962 348.511 245.632 369.888 245.632Z",
    fill: "url(#paint9_linear_237_95)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_237_95",
    x1: 98.501,
    y1: -0.000976562,
    x2: 225.577,
    y2: -0.000976562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.022,
    stopColor: "#6A647F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4C5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_237_95",
    x1: 89.5435,
    y1: 18.188,
    x2: 178.483,
    y2: 18.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#FFB3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF88CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_237_95",
    x1: 332.49,
    y1: -0.000976562,
    x2: 459.566,
    y2: -0.000976562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4C5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978,
    stopColor: "#6A647F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_237_95",
    x1: 379.584,
    y1: 18.188,
    x2: 468.524,
    y2: 18.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF88CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#FFB3DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_237_95",
    x1: 122.105,
    y1: 25.9658,
    x2: 435.961,
    y2: 25.9658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.022,
    stopColor: "#6A647F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4C5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_237_95",
    x1: 43.4761,
    y1: 291.236,
    x2: 191.863,
    y2: 291.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#FFB3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF88CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_237_95",
    x1: 163.596,
    y1: 425.38,
    x2: 394.47,
    y2: 425.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF88CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#FFB3DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_237_95",
    x1: 105.445,
    y1: 270.835,
    x2: 452.622,
    y2: 270.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF88CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#FFB3DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_237_95",
    x1: 149.473,
    y1: 245.632,
    x2: 226.886,
    y2: 245.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.022,
    stopColor: "#6A647F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4C5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_237_95",
    x1: 331.182,
    y1: 245.632,
    x2: 408.595,
    y2: 245.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4C5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978,
    stopColor: "#6A647F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat);
export default __webpack_public_path__ + "static/media/Cat.728d7c0ac693308299319e8a54d4cb90.svg";
export { ForwardRef as ReactComponent };